/**
 * Colour a referee level pill by grade. Matching is case-insensitive and
 * tolerant of variants ("International Candidate", "FIVB International", …).
 *
 *   Beginner       → grey
 *   Regional       → green
 *   National       → blue
 *   International   → gold (amber)
 *
 * Full class literals are returned so Tailwind's content scanner keeps them.
 */
export function levelPillClass(level: string | undefined | null): string {
    const l = (level || '').toLowerCase();
    if (l.includes('international')) return 'bg-amber-100 text-amber-800';
    if (l.includes('national'))     return 'bg-blue-100 text-blue-800';
    if (l.includes('regional'))     return 'bg-emerald-100 text-emerald-800';
    if (l.includes('beginner'))     return 'bg-slate-200 text-slate-700';
    return 'bg-slate-100 text-slate-600';
}

/**
 * Sort rank by seniority: International first, then National, Regional,
 * Beginner, with anything unknown last. ("international" is checked before
 * "national" because the former contains the latter.) Lower = higher up.
 */
export function levelRank(level: string | undefined | null): number {
    const l = (level || '').toLowerCase();
    if (l.includes('international')) return 0;
    if (l.includes('national'))     return 1;
    if (l.includes('regional'))     return 2;
    if (l.includes('beginner'))     return 3;
    return 4;
}
